import {createAsyncReducer} from '../../standard-actions/reducers'
import {
  ILoadStrategicDeviceDetailsAction,
  ILoadStrategicDeviceDetailsSuccessAction,
  ILoadStrategicDeviceDetailsErrorAction,
} from '../actions/load-strategic-device-details'
import {IMobilityState} from '../state'
import {initialState} from '../state/initial-state'

export type LoadStrategicDeviceDetailsAction =
  | ILoadStrategicDeviceDetailsAction
  | ILoadStrategicDeviceDetailsSuccessAction
  | ILoadStrategicDeviceDetailsErrorAction

const init = (state: IMobilityState, action: LoadStrategicDeviceDetailsAction) => ({
  ...state,
  strategicDeviceDetailsData: {
    ...initialState.strategicDeviceDetailsData,
    status: action.status,
  },
})

const success = (state: IMobilityState, action: LoadStrategicDeviceDetailsAction) => ({
  ...state,
  strategicDeviceDetailsData: {
    ...initialState.strategicDeviceDetailsData,
    status: action.status,
    data: (action as ILoadStrategicDeviceDetailsSuccessAction).data,
  },
})

const failure = (state: IMobilityState, action: LoadStrategicDeviceDetailsAction) => ({
  ...state,
  strategicDeviceDetailsData: {
    ...initialState.strategicDeviceDetailsData,
    status: action.status,
    error: (action as ILoadStrategicDeviceDetailsErrorAction).error,
  },
})

export const loadStrategicDeviceDetailsReducer = createAsyncReducer(
  initialState,
  init,
  success,
  failure,
)
